var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRightArrowIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_15_1239_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.50992e-09 -0.0287101 0.00293718 2.56777e-10 8.50136 13.7507)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 402.823,
    height: 1128.32,
    fill: "url(#paint0_diamond_15_1239)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 402.823,
    height: 1128.32,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_15_1239)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 402.823,
    height: 1128.32,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_15_1239)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 402.823,
    height: 1128.32,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_15_1239)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46984 3.53068C5.32894 3.38979 5.24979 3.19869 5.24979 2.99943C5.24979 2.80017 5.32894 2.60908 5.46984 2.46818C5.61074 2.32729 5.80183 2.24813 6.00109 2.24813C6.20035 2.24813 6.39144 2.32729 6.53234 2.46818L11.5323 7.46818C11.6023 7.53786 11.6577 7.62065 11.6956 7.71182C11.7334 7.80298 11.7529 7.90072 11.7529 7.99943C11.7529 8.09814 11.7334 8.19588 11.6956 8.28705C11.6577 8.37821 11.6023 8.461 11.5323 8.53068L6.53234 13.5307C6.39144 13.6716 6.20035 13.7507 6.00109 13.7507C5.80183 13.7507 5.61073 13.6716 5.46984 13.5307C5.32894 13.3898 5.24979 13.1987 5.24979 12.9994C5.24979 12.8002 5.32894 12.6091 5.46984 12.4682L9.93796 8.00006L5.46984 3.53068Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.65490198135375977,\"g\":0.49411764740943909,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.98823529481887817,\"g\":0.85098040103912354,\"b\":0.43921568989753723,\"a\":1.0},\"position\":0.50},{\"color\":{\"r\":0.65490198135375977,\"g\":0.49411764740943909,\"b\":0.0078431377187371254,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":5.0198377721244469e-06,\"m01\":5.8743686676025391,\"m02\":5.5641708374023438,\"m10\":-57.420249938964844,\"m11\":5.1355362984395470e-07,\"m12\":42.460857391357422},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46984 3.53068C5.32894 3.38979 5.24979 3.19869 5.24979 2.99943C5.24979 2.80017 5.32894 2.60908 5.46984 2.46818C5.61074 2.32729 5.80183 2.24813 6.00109 2.24813C6.20035 2.24813 6.39144 2.32729 6.53234 2.46818L11.5323 7.46818C11.6023 7.53786 11.6577 7.62065 11.6956 7.71182C11.7334 7.80298 11.7529 7.90072 11.7529 7.99943C11.7529 8.09814 11.7334 8.19588 11.6956 8.28705C11.6577 8.37821 11.6023 8.461 11.5323 8.53068L6.53234 13.5307C6.39144 13.6716 6.20035 13.7507 6.00109 13.7507C5.80183 13.7507 5.61073 13.6716 5.46984 13.5307C5.32894 13.3898 5.24979 13.1987 5.24979 12.9994C5.24979 12.8002 5.32894 12.6091 5.46984 12.4682L9.93796 8.00006L5.46984 3.53068Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_15_1239_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46984 3.53068C5.32894 3.38979 5.24979 3.19869 5.24979 2.99943C5.24979 2.80017 5.32894 2.60908 5.46984 2.46818C5.61074 2.32729 5.80183 2.24813 6.00109 2.24813C6.20035 2.24813 6.39144 2.32729 6.53234 2.46818L11.5323 7.46818C11.6023 7.53786 11.6577 7.62065 11.6956 7.71182C11.7334 7.80298 11.7529 7.90072 11.7529 7.99943C11.7529 8.09814 11.7334 8.19588 11.6956 8.28705C11.6577 8.37821 11.6023 8.461 11.5323 8.53068L6.53234 13.5307C6.39144 13.6716 6.20035 13.7507 6.00109 13.7507C5.80183 13.7507 5.61073 13.6716 5.46984 13.5307C5.32894 13.3898 5.24979 13.1987 5.24979 12.9994C5.24979 12.8002 5.32894 12.6091 5.46984 12.4682L9.93796 8.00006L5.46984 3.53068Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_15_1239",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCD970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A77E02"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRightArrowIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RightArrowIcon.100cb8b2.svg";
export { ForwardRef as ReactComponent };